import { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import { MdSearch } from 'react-icons/md';
import HeaderSearch from './HeaderSearch';

const Search = ({ router, modifier }) => {
  const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
  const [currentSearchTerm, setCurrentSearchTerm] = useState('');

  const handleSearchTerm = value => {
    setCurrentSearchTerm(value);
  };

  const handleCloseSearchBar = () => {
    setCurrentSearchTerm('');
    setIsSearchBarOpen(false);
  };

  return (
    <div className={modifier}>
      {currentSearchTerm && (
        <div role="button" className="search-modal-overlay" onClick={handleCloseSearchBar} />
      )}

      {!isSearchBarOpen && (
        <div
          className="search-wrapper search-wrapper--toggler"
          onClick={() => setIsSearchBarOpen(true)}>
          <div className="search-wrapper__disclaimer">SEARCH</div>

          <div className="search-wrapper__icon">
            <i>
              <MdSearch />
            </i>
          </div>
        </div>
      )}

      {isSearchBarOpen && (
        <HeaderSearch
          handleSearchTerm={handleSearchTerm}
          setIsSearchBarOpen={setIsSearchBarOpen}
          isSearchBarOpen={isSearchBarOpen}
          currentSearchTerm={currentSearchTerm}
          closeSearchBar={handleCloseSearchBar}
          router={router}
        />
      )}
    </div>
  );
};

Search.propTypes = {
  router: PropTypes.object.isRequired,
  modifier: PropTypes.string
};

Search.defaultProps = {
  modifier: 'header__search'
};

export default withRouter(Search);
